// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".letras-escritorio {\n  color: #323f48;\n  font-size: 85%;\n}\n.letras-digital {\n  color: #662483;\n  font-size: 85%;\n}\n[dir=ltr] .letras-digital {\n  margin-left: 10px;\n}\n[dir=rtl] .letras-digital {\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
